/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-underscore-dangle */
import React, {
  useContext, useEffect, useState, useRef, useMemo,
} from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import isEmpty from 'lodash/isEmpty';

import { withTranslation } from 'language/i18n';
import { Button } from 'components/common';
import { isUserHighestBidder } from 'utils/bidHelper';
import { UserContext } from 'contexts/userContext';
import maskAmount from 'utils/maskAmount';
import { StatusContext } from 'contexts/statusContext';
import { getCurrency } from 'models/payment';
import { MACHINE_STATE } from 'constants/common';
import Bid from './Bid';
import AuctionHistory from './AuctionHistory';
import AuctionResult from './AuctionResult';

const AuctionDetail = ({
  t, setHowToAuctionWorkModalVisible, setMarketPlaceModalVisible, setCheckBidModalData, machine, offers, minimumIncrement, machineSoldPrice, timeLeft, isTimeOver,
}) => {
  const router = useRouter();
  const { setErrorState } = useContext(StatusContext);
  const { userData, isLoggedIn } = useContext(UserContext);
  const user = userData;

  const [offerBounceEffect, setOfferBounceEffect] = useState(false);
  const [highOfferCurrency, setHighOfferCurrency] = useState(0);
  const [buyNowCurrency, setBuyNowCurrency] = useState(0);

  const getHighOfferCurrency = async () => {
    const highOfferCurr = await getCurrency(offers?.length > 0 ? offers[0].offer : machine.auctionStartPrice);
    setHighOfferCurrency(highOfferCurr);
  };

  const getBuyNowCurrency = async () => {
    const buyNowCurr = await getCurrency(machine.buyNowPrice);
    setBuyNowCurrency(buyNowCurr);
  };

  useEffect(() => {
    getHighOfferCurrency();
  }, [offers]);

  useEffect(() => {
    getBuyNowCurrency();
  }, [machine]);

  const bidTextByBidStatus = (bidStatus) => {
    if (bidStatus === 'active') {
      return 'green2';
    }
    if (bidStatus === 'close') {
      return 'red2';
    }
    return 'red2';
  };

  const findMainPrice = useMemo(() => {
    if (machineSoldPrice > 0) {
      return machineSoldPrice;
    }
    return offers?.length > 0 ? offers[0].offer : machine.auctionStartPrice;
  }, [machineSoldPrice, offers, machine]);

  const auctionHistoryRef = useRef();

  useEffect(() => {
    setOfferBounceEffect(true);
    setTimeout(() => {
      setOfferBounceEffect(false);
    }, 3000);
  }, [offers]);

  const scrollToAuctionHistory = () => {
    auctionHistoryRef.current.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    });
  };

  const buyNow = () => {
    if (isLoggedIn) {
      router.push('/checkout/buy-now/[id]', `/checkout/buy-now/${machine.id}`);
    } else {
      setErrorState({
        title: t('alert'),
        text: 'Satın alabilmeniz için giriş yapmanız gerekmektedir.',
        buttonText: t('login'),
        onClickButton: () => {
          setErrorState({});
          router.push({
            pathname: '/login',
            query: {
              redirectTo: router.asPath,
            },
          });
        },
      });
    }
  };

  return (
    <div className="row">
      <div className="col">
        <div className="row">
          {
            isLoggedIn && !isTimeOver && isUserHighestBidder(user.id, offers)
              && (
                <div className="col text-center mb-2">
                  <div className={`fw-900 text-${bidTextByBidStatus('active')} mb-1`}>{t('youAreTheHighestBidder')}</div>
                  <div className="fs-13 text-green2">{t('yourMaximumBidAmount')}</div>
                </div>
              )
          }
          <AuctionResult machine={machine} offers={offers} isTimeOver={isTimeOver} />
        </div>

        <div className="row justify-content-center mb-4">
          <div className="col-auto text-center">
            <div className={`fs-35 fw-900 mb-2 animate__animated ${offerBounceEffect && 'animate__bounceIn'}`}>
              {maskAmount(findMainPrice)}
            </div>
            <div className="fs-15">
              {offers?.length > 0 ? t('currentHighOffer') : 'Başlangıç Fiyatı'}
              {' '}
              <span className="text-gray3 fs-13">
                {`(${t('approx')} ${maskAmount(highOfferCurrency, 'TRY')})`}
              </span>
            </div>
          </div>
        </div>

        {/* Auction Infos */}
        <div className="row">
          <div className="col text-center">
            <div className="fs-13 fw-900 text-gray10 mb-1">{maskAmount(minimumIncrement)}</div>
            <div className="fs-12 text-gray10">{t('bidIncrement')}</div>
          </div>
          <div className="col text-center">
            <div className="fs-13 fw-900 text-gray10 mb-1">{offers?.length}</div>
            <div className="fs-12 text-gray10">
              Teklifler
              {' '}
              <a className="text-black1" onClick={() => scrollToAuctionHistory()}>(göster)</a>
            </div>
          </div>
          <div className="col text-center">
            <div className="fs-13 fw-900 text-gray10 mb-1">{offers?.length > 0 ? offers[0].userId.substring(0, 10) : '-'}</div>
            <div className="fs-12 text-gray10">{t('highestBidder')}</div>
          </div>
          <div className="col text-center">
            <div className="fs-13 fw-900 text-gray10 mb-1">-</div>
            <div className="fs-12 text-gray10">Rezervasyon Durumu</div>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <div className="separator separator--horizontal mt-4 mb-4" />
          </div>
        </div>

        {
          user?.email !== machine.owner.email && machine.state === MACHINE_STATE.IN_EVENT && !isEmpty(timeLeft)
            && (
              <>
                <Bid
                  setMarketPlaceModalVisible={setMarketPlaceModalVisible}
                  setCheckBidModalData={setCheckBidModalData}
                />

                { machine.hasBuyNow
                    && (
                      <div>
                        <div className="row">
                          <div className="col">
                            <div className="separator separator--horizontal separator--neg-margin-15 mb-4" />
                          </div>
                        </div>
                        <div className="row mb-4">
                          <div className="col-15 col-md-9 mb-3 mb-md-0">
                            <div className="fs-35 fw-900 mb-2">{maskAmount(machine.buyNowPrice)}</div>
                            <div className="fs-15">
                              {t('buyNowPrice')}
                              {' '}
                              <span className="text-gray3 fs-13">
                                {`(${t('approx')} ${maskAmount(buyNowCurrency, 'TRY')}`}
                              </span>
                            </div>
                          </div>
                          <div className="col-15 col-md-6 pl-md-0">
                            <Button
                              disabled={findMainPrice > machine.buyNowPrice && true}
                              htmlType="submit"
                              className={[
                                'im-button im-button--green2 im-button--fluid im-button--gutter-5 im-button--center im-button--size-60 fw-900',
                                findMainPrice > machine.buyNowPrice ? 'text-black' : 'text-white',
                              ].join(' ')}
                              label="Hemen Al"
                              onClick={() => buyNow()}
                            />
                          </div>
                        </div>
                      </div>
                    )}

                <div className="row">
                  <div className="col">
                    <div className="separator separator--horizontal separator--neg-margin-15 mb-3" />
                  </div>
                </div>
              </>
            )
        }

        <div className="row mb-3">
          <div className="col text-center">
            <div className="fw-900 fs-13 text-gray4 lh-1p4">{t('vatNotIncluded')}</div>
            <span className="fs-11 text-gray3">
              {t('confirmYourOfferFromThePage')}
              {' '}
              <a onClick={() => setHowToAuctionWorkModalVisible(true)}>{t('findOutHowItWorks')}</a>
            </span>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <div className="separator separator--horizontal separator--neg-margin-15 mb-4" />
          </div>
        </div>
        <AuctionHistory offers={offers} machine={machine} auctionHistoryRef={auctionHistoryRef} />
      </div>
    </div>
  );
};

AuctionDetail.propTypes = {
  t: PropTypes.func,
  setHowToAuctionWorkModalVisible: PropTypes.func,
  setMarketPlaceModalVisible: PropTypes.func,
  setCheckBidModalData: PropTypes.func,
  machine: PropTypes.object,
  offers: PropTypes.array,
  minimumIncrement: PropTypes.number,
  machineSoldPrice: PropTypes.number,
  timeLeft: PropTypes.object,
  isTimeOver: PropTypes.bool,
};

export default withTranslation('common')(AuctionDetail);
